export default __webpack_public_path__ + "static/media/invoices.724da11f.png";